import React, { useEffect, useState } from 'react';
import './BadgePopup.css';

import { Avatar, Typography } from '@mui/material';
import Divider from '@mui/material/Divider';
import { getResource } from '../../utils/Api';

/**
 * Popup affichant le détail d'un badge sélectionné par l'utilisateur.
 * Modifié par Frédérick Bethermat - 2026-03-17
 */
export default function BadgePopup({ isOpen, handleClose, selectedBadge }) {
  const [title, setTitle] = useState(''); // Titre du badge
  const [image, setImage] = useState(''); // URL de l'image du badge
  const [description, setDescription] = useState(''); // Description du badge
  const [categoryColor, setCategoryColor] = useState(''); // Couleur CSS de la catégorie
  const [categoryName, setCategoryName] = useState(''); // Nom de la catégorie
  const [obtainedAt, setObtainedAt] = useState(''); // Date d'obtention formatée en français

  /**
   * Met à jour les états locaux à chaque changement de badge sélectionné.
   */
  useEffect(() => {
    setTitle(selectedBadge ? selectedBadge.title : '');
    setImage(selectedBadge ? selectedBadge.imagePath : '');
    setDescription(selectedBadge ? selectedBadge.description : '');
    setCategoryColor(selectedBadge ? selectedBadge.category_color : '');
    setCategoryName(selectedBadge ? selectedBadge.category_name : '');

    if (selectedBadge?.obtained_at) {
      const date = new Date(selectedBadge.obtained_at);
      const formatted = date.toLocaleDateString('fr-FR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });
      setObtainedAt(formatted);
    } else {
      setObtainedAt('');
    }
  }, [selectedBadge]);

  // Ne rien rendre si la popup est fermée
  if (!isOpen) return null;

  return (
    // Overlay semi-transparent : un clic dessus ferme la popup
    <div className="popup-overlay" onClick={handleClose}>
      {/* Conteneur principal : stopPropagation empêche la fermeture au clic interne */}
      <div className="popup-container" onClick={(e) => e.stopPropagation()}>
        {/* Bouton de fermeture */}
        <button className="popup-close" onClick={handleClose}>
          ✕
        </button>

        {/* Titre du badge */}
        <h2 className="popup-title">{title}</h2>

        {/* Étiquette de catégorie avec halo coloré dynamique */}
        <span
          className="popup-category"
          style={{ boxShadow: `0 0 12px 8px ${categoryColor}` }}
        >
          Catégorie: {categoryName || 'Non catégorisé'}
        </span>

        <div className="popup-content">
          {/* Avatar du badge avec halo coloré ; image de fallback si aucune n'est définie */}
          <Avatar
            alt={title}
            src={image || getResource('badge.png')}
            className="avatar"
            sx={{ boxShadow: `0 0 8px 12px ${categoryColor}` }}
          />

          <Divider sx={{ width: '80%', borderColor: 'rgba(0,0,0,0.12)' }} />

          {/* Description textuelle du badge */}
          <Typography className="description">{description}</Typography>

          {/* Date d'obtention, affichée uniquement si elle est renseignée */}
          {obtainedAt && (
            <Typography className="obtained-at">
              Obtenu le {obtainedAt}
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
}
